<div class="acc-header" (click)="toggle($event)" [attr.data-sectorId]="sectorId" [class.open]="showBody">
  <div class="header-title">
    {{ title }}
  </div>
  <div [@rotatedState]="!showBody ? 'default' : 'rotated'" class="arrow">
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none">
  	  <path d="M6.80078 5.5L0.950782 0.73686V10.2631L6.80078 5.5Z" fill="#797979"/>
    </svg>
  </div>
</div>
<div [@smoothCollapse]="!showBody ? 'initial' : 'final' ">
  <div class="acc-body">
    <ng-content></ng-content>
  </div>
</div>
